import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Dropdown,
  Form,
  message,
  Row,
  Table,
} from "antd";
import { useForm } from "antd/es/form/Form";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";
import { useHistory } from "react-router-dom";
import { CHAT_BUSINESS_TYPE_ID } from "../../util/Constant";
import { format } from "date-fns";
import { EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { isValidElement } from "../../util/ApiHelper";
import moment from "moment";

const SearchLoggedInUserDetails = () => {
  const [form] = useForm();
  const FormItem = Form.Item;
  const history = useHistory();
  const [userDetails, setUserDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  function formatTimeFirst(dateString) {
    if (!dateString) return "-";
    try {
      return format(new Date(dateString), "dd MMM yyyy HH:mm:ss");
    } catch {
      return "Invalid Date";
    }
  }

  const getBusinessType = (businessTypeId) => {
    return CHAT_BUSINESS_TYPE_ID[businessTypeId] || "Unknown";
  };

  const navigateToDetails = (id) => {
    if (isValidElement(id)) {
      history.push(`navigation-reports/user-activity-details/${id}`);
    }
  };

  const columns = [
    {
      title: "Login Time",
      key: "loginTime",
      render: (record) => <div>{formatTimeFirst(record?.loginAt)}</div>,
    },
    {
      title: "Company Name",
      key: "companyName",
      render: (record) => <div>{record?.user?.companyName}</div>,
    },
    {
      title: "Country Code",
      key: "countryCode",
      render: (record) => <div>{record?.user?.countryCode}</div>,
    },
    {
      title: "Business Type",
      key: "businessType",
      render: (record) => (
        <div>{getBusinessType(record?.user?.businessTypeId)}</div>
      ),
    },
    {
      title: "Device Type",
      key: "deviceType",
      render: (record) => <div>{record?.deviceType}</div>,
    },
    {
      title: "Actions",
      key: "actions",
      render: (record) => (
        <div
          className="myexim-action-icon"
          onClick={(e) => e.stopPropagation()}
        >
          <Dropdown
            menu={{
              items: [
                {
                  label: "View Details",
                  key: "1",
                  icon: <EyeOutlined />,
                  onClick: () => {
                    navigateToDetails(record?.id);
                  },
                },
              ],
            }}
            trigger={["click"]}
          >
            <MoreOutlined />
          </Dropdown>
        </div>
      ),
    },
  ];

  const fetchDefaultData = async () => {
    try{
      setLoading(true);
      const response = await axiosInstance.get(
         `${BASE_API_CONFIG.baseURL}/loginsessiondetails/today`,
      );
      if (response.status === 200 || response.status === 201) {
        setUserDetails(response.data || []);
        const endDate = new Date();
        const startDate = new Date();
        form.setFieldsValue({
          startDate: moment(startDate),
          endDate: moment(endDate),
        });
      } else {
        message.error("Failed to get logged in details");
        setUserDetails([]);
      }
    }catch(error){
      console.error("Error:", error);
      setUserDetails([]);
    }finally{
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchDefaultData();
  },[]);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const data = {
        startDate: values?.startDate?.format("YYYY-MM-DD"),
        endDate: values?.endDate?.format("YYYY-MM-DD"),
      };

      const response = await axiosInstance.post(
        `${BASE_API_CONFIG.baseURL}/loginsessiondetails`,
        data
      );
      if (response.status === 200 || response.status === 201) {
        setUserDetails(response.data || []);
      } else {
        message.error("Failed to get logged in details");
        setUserDetails([]);
      }
    } catch (error) {
      message.error("An error occurred while searching user logged in details");
      console.error("Error:", error);
      setUserDetails([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      className="gx-card myexim-detail-card"
      title={
        <div className="myexim-table-title gx-text-capitalize">
          User Login Sessions
        </div>
      }
    >
      <Form form={form} onFinish={onFinish} scrollToFirstError={true}>
        <Row gutter={[16, 4]}>
          <Col xs={24} sm={24} md={8}>
            <FormItem
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Start Date"
              name="startDate"
              rules={[
                {
                  required: true,
                  message: "Start date is required",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format="DD-MM-YYYY"
                getPopupContainer={(trigger) => trigger.parentNode}
              />
            </FormItem>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="End Date"
              name="endDate"
              rules={[
                {
                  required: true,
                  message: "End date is required",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format="DD-MM-YYYY"
                getPopupContainer={(trigger) => trigger.parentNode}
              />
            </Form.Item>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={8}
            style={{ textAlign: "right", marginTop: "30px" }}
          >
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              style={{ width: 150, marginTop: "2px" }}
              loading={loading}
            >
              Search
            </Button>
          </Col>
        </Row>
      </Form>

      <Table
        columns={columns}
        dataSource={userDetails}
        rowKey="id"
        loading={loading}
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          position: ["bottomRight"],
        }}
        className="gx-table-responsive myexim-table"
      />
    </Card>
  );
};

export default SearchLoggedInUserDetails;
